function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareFrames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    style: {
      transform: "scale(0.8)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0175 0 0 1.0087 -.086866 -.050785)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.1687 6.0302h194.69v232.59h-194.69z",
    strokeLinejoin: "round",
    strokeWidth: 8.71,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.83 155.06h124.91v261.02h-124.91z",
    strokeLinejoin: "round",
    strokeWidth: 2.9846,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.15 111.99h263.6v157.65h-263.6z",
    strokeLinejoin: "round",
    strokeWidth: 2.9846,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.645 310.98h483.28v189.52h-483.28z",
    strokeLinejoin: "round",
    strokeWidth: 7.9204,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.18 25.844h124.91v431.59h-124.91z",
    strokeLinejoin: "round",
    strokeWidth: 15.225,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.77 204.16h116.3v138.69h-116.3z",
    strokeLinejoin: "bevel",
    strokeWidth: 8.71,
    style: {
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareFrames);
export default __webpack_public_path__ + "static/media/square_frames.eaee98aa21930623130525a90a38092d.svg";
export { ForwardRef as ReactComponent };